import { combineReducers } from 'redux'
import { reducer as reduxFormReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router'


import waas from './waas/comp'

const rootReducer = (history) => combineReducers({
    router: connectRouter(history),
    form: reduxFormReducer,
    waas,
})

export default rootReducer;